<section class="hint-banner">
	<a href="javascript:void(0)" (click)="closeButtonClicked.emit()" class="close-icon">
		<mat-icon>close</mat-icon>
	</a>
	<ng-content></ng-content>
</section>
